// extracted by mini-css-extract-plugin
export default {"openButton":"UB-z","modalContent":"VB-z","hideOutsideOfMobile":"WB-z"};